export default __webpack_public_path__ + "static/media/Palash.47d2e4aa.jpg";